module.exports = __webpack_public_path__ + "static/media/sale-sol-mobile.861c8f48.png";